<template>
	<div class="histogramChart">
		<div id="myChart" :style="{width: '537px', height: '300px'}"></div>
	</div>

</template>

<script>
	export default {
		name: "Chart",
		props: {
			data: Array,
			unit: String,
            flag:Boolean
		},
		data(){
			return {
				
			}
		},
        watch:{
            flag:function(newval,oldval){
                if(newval){
                    this.drawLine();
                }
            }
        },
		methods: {
            drawLine(){
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                // 绘制图表
                myChart.setOption({
                    color: ['#c23531','#ffffff'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data: ['上周', '本周']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        
                        {
                            name: '上周',
                            type: 'bar',
                            stack: 'one',
                            barWidth: 25,
                            data: [120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name: '本周',
                            type: 'bar',
                            stack: 'one',
                            barWidth: 25,
                            data: [220, 182, 191, 234, 290, 330, 310]
                        }
                    ]
                });
            }
		},
		mounted() {
			this.drawLine();
		}
	}
</script>

<style lang="less" scoped>
    .histogramChart{
        width: 28vw;
        height: 31vh;
        background-color: rgba(255,255,255,.4);
        margin-left: 1vw;
        overflow: hidden;
        position: fixed;
        bottom: 2vw;
        border-radius: 5px;
    }
</style>